<template>
  <div
    class="flex flex-col flex-shrink-0 bg-white border border-gray-300 max-w-120 md:flex-1"
  >
    <slot name="image" />

    <div class="flex flex-col flex-1 px-4 py-4 xl:p-6">
      <h3 class="pb-3 text-lg font-bold xl:text-2xl">
        {{ title }}
      </h3>

      <div class="flex-1">
        <slot />
      </div>

      <div class="pt-6 xl:pt-8">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TypeCard from '~brand-components/base/type-card/type-card'

export default TypeCard.extend()
</script>
